export const actions = {
    START_FETCHING_CUSTOMERS: 'START_FETCHING_CUSTOMERS',
    FETCHING_SUCCESSFUL_CUSTOMERS: 'FETCHING_SUCCESSFUL_CUSTOMERS',
    FETCHING_FAILED_CUSTOMERS: 'FETCHING_FAILED_CUSTOMERS',

    START_DELETE_CUSTOMER: 'START_DELETE_CUSTOMER',
    DELETE_CUSTOMER_SUCCESSFUL: 'DELETE_CUSTOMER_SUCCESSFUL',
    DELETE_CUSTOMER_FAILED: 'DELETE_CUSTOMER_FAILED',

    START_CREATE_CUSTOMER: 'START_CREATE_CUSTOMER',
    CREATE_CUSTOMER_SUCCESSFUL: 'CREATE_CUSTOMER_SUCCESSFUL',
    CREATE_CUSTOMER_FAILED: 'CREATE_CUSTOMER_FAILED',

    START_FETCHING_CUSTOMER: 'START_FETCHING_CUSTOMER',
    FETCH_CUSTOMER_SUCCESSFUL: 'FETCH_CUSTOMER_SUCCESSFUL',
    FETCH_CUSTOMER_FAILED: 'FETCH_CUSTOMER_FAILED',
    STORE_CUSTOMER_DATA: 'STORE_CUSTOMER_DATA',

    START_UPDATE_CUSTOMER: 'START_UPDATE_CUSTOMER',
    UPDATE_CUSTOMER_SUCCESSFUL: 'UPDATE_CUSTOMER_SUCCESSFUL',
    UPDATE_CUSTOMER_FAILED: 'UPDATE_CUSTOMER_FAILED',

    START_BULK_ACTIONS_DELETE_CUSTOMERS: 'START_BULK_ACTIONS_DELETE_CUSTOMERS',
    BULK_ACTIONS_DELETE_CUSTOMERS_SUCCESS: 'BULK_ACTIONS_DELETE_CUSTOMERS_SUCCESS',
    BULK_ACTIONS_DELETE_CUSTOMERS_FAILED: 'BULK_ACTIONS_DELETE_CUSTOMERS_FAILED'
};

export const initialState = {
    listingFetching: false,
    listingResponse: {
        data: [],
        meta: {},
        included: []
    },
    listingError: [],
    singleFetching: false,
    singleError: null,
    deleteSingleError: null,
    submittingBulkAction: false
};

export default (state = initialState, { type, response, iri }) => {
    switch (type) {
        case actions.START_FETCHING_CUSTOMERS: {
            return {
                ...state,
                listingFetching: true
            };
        }
        case actions.START_FETCHING_CUSTOMER: {
            return {
                ...state,
                singleFetching: true
            };
        }
        case actions.FETCH_CUSTOMER_SUCCESSFUL: {
            return {
                ...state,
                singleFetching: false
            };
        }
        case actions.STORE_CUSTOMER_DATA: {
            return { ...state, [iri]: response?.data };
        }
        case actions.FETCH_CUSTOMER_FAILED: {
            return {
                ...state,
                singleFetching: false
            };
        }
        case actions.FETCHING_SUCCESSFUL_CUSTOMERS: {
            return {
                ...state,
                listingFetching: false,
                listingResponse: response
            };
        }
        case actions.FETCHING_FAILED_CUSTOMERS: {
            return {
                ...state,
                listingFetching: false,
                listingError: response
            };
        }
        case actions.DELETE_CUSTOMER_FAILED: {
            return {
                ...state,
                deleteSingleError: response
            };
        }

        case actions.UPDATE_CUSTOMER_FAILED: {
            return {
                ...state,
                singleError: response
            };
        }

        case actions.START_BULK_ACTIONS_DELETE_CUSTOMERS: {
            return {
                ...state,
                submittingBulkAction: true
            };
        }

        case actions.BULK_ACTIONS_DELETE_CUSTOMERS_SUCCESS: {
            return {
                ...state,
                submittingBulkAction: false
            };
        }
        case actions.BULK_ACTIONS_DELETE_CUSTOMERS_FAILED: {
            return {
                ...state,
                submittingBulkAction: false
            };
        }

        default:
            return state;
    }
};
